export const NEIGHBORHOODS = [
  {
    slug: "adnan-kahveci",
    name: "Adnan Kahveci Mahallesi",
    short: "Adnan Kahveci",
    meta: "Adnan Kahveci'de elektrik arıza, tesisat, avize, priz, kamera ve internet işleri. Yerel usta aynı gün kapınızda. Hemen arayın: 0530 956 27 70",
    desc: "Adnan Kahveci Mahallesi'ndeki site ve konutlarda elektrik arızası, sigorta atması, avize ve priz montajı için aynı gün servis veriyoruz. Beylikdüzü merkeze yakın konumumuz sayesinde arızaya kısa sürede müdahale ediyoruz. Kamera, diafon ve internet hattı çekimi gibi montaj işlerinizi de temiz ve titiz şekilde teslim ediyoruz.",
  },
  {
    slug: "beykent",
    name: "Beykent Mahallesi",
    short: "Beykent",
    meta: "Beykent'te elektrik arıza, tesisat, avize, priz, kamera ve internet işleri. Yerel usta aynı gün kapınızda. Hemen arayın: 0530 956 27 70",
    desc: "Beykent'teki rezidans, site ve iş yerlerinde elektrik arıza tespiti, tesisat yenileme, aydınlatma ve LED montajı yapıyoruz. Üniversite bölgesindeki yoğun konut yapısına hakim olduğumuz için bina altyapılarında hızlı çözüm üretiyoruz. Acil arızalarda telefonu doğrudan usta açar, aynı gün adresinize geliriz.",
  },
  {
    slug: "cumhuriyet",
    name: "Cumhuriyet Mahallesi",
    short: "Cumhuriyet",
    meta: "Cumhuriyet Mahallesi'nde elektrik arıza, tesisat, priz, avize ve sigorta işleri. Yerel usta aynı gün kapınızda. Arayın: 0530 956 27 70",
    desc: "Cumhuriyet Mahallesi'nde konut, çarşı esnafı ve iş yerlerinin tüm elektrik işlerini üstleniyoruz. Sigorta ve pano yenileme, eski tesisatın güncellenmesi, priz ve anahtar montajı başlıca hizmetlerimiz. İş bitiminde ortamı temiz bırakır, yaptığımız işçiliğe garanti veririz.",
  },
  {
    slug: "baris",
    name: "Barış Mahallesi",
    short: "Barış",
    meta: "Barış Mahallesi'nde elektrik arıza, tesisat, avize, kamera ve diafon işleri. Yerel usta aynı gün kapınızda. Arayın: 0530 956 27 70",
    desc: "Barış Mahallesi'ndeki konut ve esnaflara elektrik arıza, tesisat, aydınlatma ve güvenlik kamerası montajı hizmeti sunuyoruz. Bina diafon sistemlerinin yenilenmesi ve görüntülü kapı telefonu kurulumu da yaptığımız işler arasında. Net fiyatla çalışır, işe başlamadan ücreti konuşuruz.",
  },
  {
    slug: "yakuplu",
    name: "Yakuplu Mahallesi",
    short: "Yakuplu",
    meta: "Yakuplu'da elektrik arıza, tesisat, avize, LED, kamera ve internet hattı işleri. Yerel usta aynı gün kapınızda. Arayın: 0530 956 27 70",
    desc: "Yakuplu'da marina ve sahil hattındaki konutlardan sanayi bölgesindeki iş yerlerine kadar tüm elektrik işlerine bakıyoruz. Bahçe ve alan aydınlatması, gizli LED şerit, spot montajı gibi dekoratif işlerde deneyimliyiz. Acil arızalarda aynı gün müdahale ediyoruz.",
  },
  {
    slug: "ambarli",
    name: "Ambarlı Mahallesi",
    short: "Ambarlı",
    meta: "Ambarlı'da elektrik arıza, pano, tesisat, kamera ve data hattı işleri. Yerel usta aynı gün kapınızda. Hemen arayın: 0530 956 27 70",
    desc: "Ambarlı'da liman çevresindeki sanayi tesisleri ve konutlar için elektrik pano, sigorta, tesisat ve data hattı işleri yapıyoruz. İş yerlerinin güvenlik kamerası ve network altyapı kurulumlarını da üstleniyoruz. Telefonu doğrudan işi yapacak usta açar.",
  },
  {
    slug: "marmara",
    name: "Marmara Mahallesi",
    short: "Marmara",
    meta: "Marmara Mahallesi'nde elektrik arıza, tesisat, avize, priz ve uydu işleri. Yerel usta aynı gün kapınızda. Arayın: 0530 956 27 70",
    desc: "Marmara Mahallesi'ndeki site ve rezidanslarda elektrik arıza tespiti, avize ve LED montajı, priz hattı çekimi yapıyoruz. Uydu ve TV tesisatı, internet prizi ve kablo sonlandırma işlerini de aynı titizlikle teslim ediyoruz. Yakın konumdayız, acil durumlarda kısa sürede kapınızdayız.",
  },
  {
    slug: "gurpinar",
    name: "Gürpınar Mahallesi",
    short: "Gürpınar",
    meta: "Gürpınar'da elektrik arıza, tesisat, avize, kamera ve diafon işleri. Yerel usta aynı gün kapınızda. Hemen arayın: 0530 956 27 70",
    desc: "Gürpınar'da sahil siteleri ve mahalle içi konutlarda elektrik arıza, tesisat yenileme, aydınlatma montajı hizmeti veriyoruz. Bina girişlerine diafon ve görüntülü kapı telefonu, dairelere kamera sistemi kuruyoruz. Temiz çalışır, iş bittiğinde ortamı derli toplu teslim ederiz.",
  },
  {
    slug: "dereagzi",
    name: "Dereağzı Mahallesi",
    short: "Dereağzı",
    meta: "Dereağzı'nda elektrik arıza, tesisat, priz, avize ve internet hattı işleri. Yerel usta aynı gün kapınızda. Arayın: 0530 956 27 70",
    desc: "Dereağzı'ndaki yeni konut projeleri ve müstakil evlerde elektrik tesisatı kurulumu, arıza onarımı ve montaj işleri yapıyoruz. Yeni taşınanlar için priz ekleme, avize montajı ve internet hattı çekimini tek seferde hallediyoruz. Garantili işçilik, net fiyat.",
  },
  {
    slug: "kavakli",
    name: "Kavaklı Mahallesi",
    short: "Kavaklı",
    meta: "Kavaklı'da elektrik arıza, tesisat, pano, kamera ve data hattı işleri. Yerel usta aynı gün kapınızda. Hemen arayın: 0530 956 27 70",
    desc: "Kavaklı'da sanayi ve konut bölgelerinin tüm elektrik ihtiyaçlarına hizmet veriyoruz. Ana şalter ve klemens yenileme, kaçak akım rölesi montajı, kamera ve data altyapısı kurulumu başlıca işlerimiz. Aracı firma yok, telefonu doğrudan usta açar.",
  },
  {
    slug: "buyuksehir",
    name: "Büyükşehir Mahallesi",
    short: "Büyükşehir",
    meta: "Büyükşehir Mahallesi'nde elektrik arıza, tesisat, avize, priz ve uydu işleri. Yerel usta aynı gün kapınızda. Arayın: 0530 956 27 70",
    desc: "Büyükşehir Mahallesi'ndeki konutlarda elektrik arıza, tesisat, avize ve priz montajı işlerini aynı gün yapıyoruz. Uydu anten ayarı, TV tesisatı ve internet prizi kurulumu da hizmetlerimiz arasında. İşe başlamadan fiyatı konuşur, sürpriz ücret çıkarmayız.",
  },
  {
    slug: "sahil",
    name: "Sahil Mahallesi",
    short: "Sahil",
    meta: "Sahil Mahallesi'nde elektrik arıza, tesisat, avize, LED ve kamera işleri. Yerel usta aynı gün kapınızda. Arayın: 0530 956 27 70",
    desc: "Sahil Mahallesi'ndeki denize yakın konut ve iş yerlerinde elektrik arıza, tesisat ve aydınlatma işleri yapıyoruz. Bahçe aydınlatması, dış mekân priz ve kamera montajında deneyimliyiz. Beylikdüzü'nün yerel ustası olarak acil arızalarda aynı gün müdahale ediyoruz.",
  },
];
